<template>
  <SectionFrame v-if="projects.length || inStudio" :section="section" :index="index" :heading="heading" label="Our work">
    <template v-if="projects.length">
      <div v-if="layout === 'featured'" class="s2-work-featured">
        <a :href="back(link(projects[0]))" class="t-link s2-work-big mo-reveal">
          <img v-if="projects[0].cover" :src="projects[0].cover" v-bind="imgAttrs(projects[0].cover, '(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw')" :alt="imgAlt(projects[0].cover, projects[0].title)" class="t-photo s2-work-img" loading="lazy">
          <span class="s2-work-meta"><b class="t-h3">{{ projects[0].title }}</b><span class="s2-muted s2-small">{{ meta(projects[0]) }}</span></span>
        </a>
        <div class="s2-work-small mo-stagger">
          <a v-for="p in projects.slice(1, 3)" :key="p.id" :href="back(link(p))" class="t-link">
            <img v-if="p.cover" :src="p.cover" v-bind="imgAttrs(p.cover, '(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw')" :alt="imgAlt(p.cover, p.title)" class="t-photo s2-work-img" loading="lazy">
            <span class="s2-work-meta"><b>{{ p.title }}</b><span class="s2-muted s2-small">{{ meta(p) }}</span></span>
          </a>
        </div>
      </div>
      <div v-else class="s2-grid mo-stagger" style="--s2-cols: 3">
        <a v-for="p in projects" :key="p.id" :href="back(link(p))" class="t-link s2-work-card">
          <img v-if="p.cover" :src="p.cover" v-bind="imgAttrs(p.cover, '(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw')" :alt="imgAlt(p.cover, p.title)" class="t-photo s2-work-img" loading="lazy">
          <span class="s2-work-meta"><b class="t-h3">{{ p.title }}</b><span v-if="meta(p)" class="s2-muted s2-small">{{ meta(p) }}</span></span>
          <span v-if="layout === 'before-after' && p.intro" class="t-body s2-muted s2-clamp">{{ p.intro }}</span>
        </a>
      </div>
      <p class="s2-more"><a :href="back('/showcase')" class="t-link s2-u">{{ section.moreText || "See all our work" }}</a></p>
    </template>
    <StudioGap v-else>Add a project to your portfolio, then it shows here.</StudioGap>
  </SectionFrame>
</template>

<script setup>
import {useImageAlt} from "@/composables/useImageAlt.js";
const imgAlt = useImageAlt();
import {imgAttrs} from "@/utils/photoSizes.js";
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import StudioGap from "./StudioGap.vue";
import {layoutOf, pickProjects} from "@/utils/sectionLogic.js";
import {studioMode} from "@/classes/previewBridge.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}, data: {type: Object, default: () => ({})}});
const inStudio = computed(() => studioMode.value !== "off");
const layout = computed(() => layoutOf(props.section, ["three", "featured", "before-after"]));
const heading = computed(() => props.section.heading ?? "Our work");
const projects = computed(() => pickProjects(props.data.projects, props.section));
const TYPES = {kitchen: "Kitchen", bathroom: "Bathroom", garden: "Garden", build: "Build", photo_shoot: "Photo shoot", general: ""};
const meta = (p) => [props.section.showType !== false ? (TYPES[p.type] ?? p.type) : "", props.section.showPlace ? p.place : ""].filter(Boolean).join(" · ");
const link = (p) => `/showcase/${p.slug}`;
</script>

<style>
.s2-work-img { width: 100%; height: auto; aspect-ratio: 4 / 3; object-fit: cover; display: block; }
.s2-work-meta { display: flex; flex-direction: column; gap: .15rem; margin-top: .7rem; }
.s2-work-featured { display: grid; grid-template-columns: minmax(0, 1.6fr) minmax(0, 1fr); gap: var(--t-gap); }
.s2-work-small { display: grid; gap: var(--t-gap); }
.s2-work-big .s2-work-img { aspect-ratio: 5 / 4; }
@media (max-width: 760px) { .s2-work-featured { grid-template-columns: minmax(0, 1fr); } }
.s2-work-card:hover b, .s2-work-big:hover b { text-decoration: underline; }
</style>
